// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"251":"6de112c0","406":"0a907ad4"}[chunkId] + ".chunk.js";
};